import ExpandToggle from '@threespot/expand-toggle';

const init = () => {
  document.querySelectorAll('.FAQBlock-toggle[data-expands]').forEach(el => new ExpandToggle(el));
};

// Init on initial page load
init();
